import calls from '@/backend/api-calls'

const state = () => ({
  masterProductions: [],
  selected: [],
  // allSelected: false,
  firstLoad: true,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
  }
})

// getters
const getters = {
  masterProductionIds: state => {
    return state.masterProductions.map(d => d.id);
  },
  stepsSelected: state => {
    if (state.masterProductions.length > 0) {
      return state.masterProductions.map(
        d => {
          let copy = JSON.parse(JSON.stringify(d));
          copy.production_steps = copy.production_steps.filter(
            d => state.selected.includes(d.id)
          );
          return copy
        }
      ).filter(d => d.production_steps.length > 0);
    } else {
      return []
    }
  }
}

// actions
const actions = {
  getMasterProductions: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.masterProductions.get(parameters)
        .then(resp => {
          commit("setMasterProductions", resp.data);
          commit("setLoading", false);
          commit("setFirstLoad", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  refreshMasterProduction: ({commit}, masterProductionId) => {
    return new Promise((resolve, reject) => {
      calls.masterProduction.get(masterProductionId)
        .then(resp => {
          commit("setUpdatedMasterProduction", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  // toggleAllSelected: ({commit, getters}, ) => {
  //   if (value) {
  //     commit("selectAll", getters.ids);
  //   } else {
  //     commit("deselectAll");
  //   }
  // }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setFirstLoad(state, status) {
    state.firstLoad = status;
  },
  setMasterProductions(state, data) {
    state.pagination = data.pagination;
    state.masterProductions = data.results;
  },
  setUpdatedMasterProduction(state, data) {
    state.masterProductions.forEach((masterProduction, i) => {
      if (masterProduction.id == data.id) {
        state.masterProductions.splice(i, 1, data);
      }
    })
  },
  setQuantityAssigned(state, { masterProductionId, productionStepId, value }) {
    state.masterProductions.forEach((masterProduction) => {
      if (masterProduction.id == masterProductionId) {
        masterProduction.production_steps.forEach(step => {
          if (step.id == productionStepId) {
            step.qty_assigned = value;
          }
        })
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}